import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { MCmsLanguagePicker, MLoader } from '../components/molecules';
import {
	OFaqInfo,
	ODestructiveButtons,
} from '../components/organisme';

import { CMS_CONFIG } from '../config/cms.config';
import { setCmsHead } from '../redux/head/headActions';
import store from '../redux/store/store';
import {
	updateForm,
	addFaqItem,
	updateFaqItem,
	initForm,
} from '../redux/cms/cmsActions';
import withAuthGuard from '../helpers/withAuthGuard';

import { routes } from '../constants';

const mapStateToProps = state => ({
	languages: state.head.utilities.languages,
	form: state.cms.form,
	isValid: state.cms.isFormValid,
	isUploading: state.cms.isUploading,
	uploadingFailed: state.cms.uploadingFailed,
});

class CreateFaqPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isEditMode: false,
			language: undefined,
		};

		this.bindHandles();
	}

	componentDidMount() {
		const editMode = this.checkForEditMode();

		this.props.setCmsHead({ ...CMS_CONFIG.FAQ.header.create });
		this.initForm({ editMode });
	}


	componentWillReceiveProps(props) {
		if (!this.state.language && props.languages.length > 0) {
			this.setState({ language: props.languages[0].uuid });
		}
	}

	handleLanguageSwitch(language) {
		this.setState({ language });
	}

	checkForEditMode() {
		const isEditMode = 'faqItemId' in this.props.match.params && this.props.match.params.faqItemId;

		this.setState({ isEditMode });

		return isEditMode;
	}

	initForm({ editMode = false }) {
		const values = {};
		const faqCats = store.getState().content.faq.filter(item => item.id === this.props.match.params.slug);
		if (!faqCats || !faqCats.length || faqCats.length === 0) {
			this.props.history.push(`${routes.CMS.DEFAULT}${routes.CMS.FAQ}`);
			return;
		}

		faqCats.forEach((faqCat) => {
			values[`${faqCat.languageUuid}-faqcategoryUuid`] = faqCat.uuid;
		});

		if (editMode) {
			faqCats.forEach((faqCat) => {
				const faq = faqCat.faqs.find(item => item.id === this.props.match.params.faqItemId);
				values[`${faq.languageUuid}-title`] = faq.title;
				values[`${faq.languageUuid}-description`] = faq.description;
			});
			values.id = this.props.match.params.faqItemId;
		}

		this.props.initForm({
			fields: CMS_CONFIG.CREATE.faq(this.props.languages),
			values,
		});
	}

	bindHandles() {
		this.handleFieldChange = this.handleFieldChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleLanguageSwitch = this.handleLanguageSwitch.bind(this);
		this.handleLangFieldChange = this.handleLangFieldChange.bind(this);
	}

	handleFieldChange({ field, value, error }) {
		this.props.updateForm({ key: field, value, valid: !error });
	}

	handleLangFieldChange({ field, value, error }) {
		if (this.state.language) {
			this.props.updateForm({ key: `${this.state.language}-${field}`, value, valid: !error });
		}
	}

	handleSave() {
		if (!this.props.isValid) {
			return;
		}

		if (this.state.isEditMode) {
			this.props.updateFaqItem(this.props.history);
		} else {
			this.props.addFaqItem(this.props.history);
		}
	}


	render() {
		let content;

		if (this.props.isUploading) {
			content = <MLoader className="article--loader article--loader-create" />;
		}

		return (
			<div className="layout-cms--wrapper">
				<div className="layout-cms--content-body--create">
					<div className="section-cms--language-picker">
						<MCmsLanguagePicker
							items={this.props.languages}
							active={this.state.language}
							onClick={this.handleLanguageSwitch}
						/>
					</div>
					<OFaqInfo
						title={get(this.props.form, `${this.state.language}-title.value`, '')}
						description={get(this.props.form, `${this.state.language}-description.value`, '')}
						onTitleChange={(value, error) => this.handleLangFieldChange({ field: 'title', value, error })}
						onDescriptionChange={(value, error) => this.handleLangFieldChange({ field: 'description', value, error })}
					/>
				</div>
				<div className="section-cms--destructive-buttons">
					<ODestructiveButtons
						saveEnabled={this.props.isValid}
						onSave={this.handleSave}
					/>
				</div>
				{content}
			</div>
		);
	}
}

CreateFaqPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	updateForm: PropTypes.func.isRequired,
	addFaqItem: PropTypes.func.isRequired,
	updateFaqItem: PropTypes.func.isRequired,
	initForm: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	updateForm,
	addFaqItem,
	updateFaqItem,
	initForm,
})(CreateFaqPage)));



// WEBPACK FOOTER //
// ./src/CMS/create-faq.js